/* Paper Dealer — small quality-of-life helpers (PD 2026-09) */
(function () {
  // "/" opens search on desktop (like GitHub/YouTube), unless typing in a field.
  document.addEventListener('keydown', function (e) {
    if (e.key !== '/' || e.ctrlKey || e.metaKey || e.altKey) return;
    var t = e.target;
    if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
    var btn = document.querySelector('search-button button, .search-action button');
    if (!btn) return;
    e.preventDefault();
    btn.click();
  });
})();

/* PD 2026-09 — no white flash on hover.
   1. Product cards: the "second image on hover" is lazy and sits in a hidden slide, so it only starts loading
      on the first hover (white frame, then the image). Cards near the viewport now fetch it in advance.
   2. Mega menu: panel artwork is lazy inside a hidden panel. The first time the pointer enters the nav bar,
      all panel images are requested, so they are ready by the time a panel opens. Pointer devices only. */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  function eager(root) {
    root.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      img.loading = 'eager';
      if (img.decode) img.decode().catch(function () {});
    });
  }
  function initCards() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        eager(e.target);
      });
    }, { rootMargin: '200px 0px' });
    document.querySelectorAll('.card-gallery').forEach(function (g) {
      if (g.querySelectorAll('img').length > 1) io.observe(g);
    });
  }
  function initMenu() {
    var nav = document.getElementById('pd-mega-nav');
    if (!nav) return;
    var done = false;
    nav.addEventListener('pointerenter', function () {
      if (done) return;
      done = true;
      eager(nav);
      var wrap = document.getElementById('pd-mega-wrap');
      if (wrap) eager(wrap);
    });
  }
  function start() { initCards(); initMenu(); }
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start);
})();

/* PD 2026-09 — purchase limit ("1 per customer" on MTG Collector Booster Boxes and One Piece booster boxes).
   Mirrors snippets/pd-purchase-limit.liquid. 1) caps the quantity stepper on the product page;
   2) if the cart ends up above the limit (e.g. added twice), the line is set back to the limit. */
(function () {
  function limitFor(item) {
    var t = (item.product_type || '');
    var title = (item.product_title || '').toLowerCase();
    if (t === 'Collector Booster Box') return 1;
    if (t.indexOf('Booster Box') !== -1 && title.indexOf('one piece') !== -1) return 1;
    return 0;
  }
  function capInputs() {
    document.querySelectorAll('[data-pd-limit]').forEach(function (note) {
      var max = parseInt(note.getAttribute('data-pd-limit'), 10); if (!max) return;
      var scope = note.closest('.product-details, .product-information, form, section') || document;
      scope.querySelectorAll('input[name="quantity"]').forEach(function (inp) {
        inp.max = max; if (parseInt(inp.value, 10) > max) inp.value = max;
        inp.addEventListener('change', function () { if (parseInt(inp.value, 10) > max) inp.value = max; });
      });
    });
  }
  var busy = false;
  function guardCart() {
    if (busy || !window.fetch) return;
    busy = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var fix = (cart.items || []).filter(function (i) { var l = limitFor(i); return l && i.quantity > l; });
      if (!fix.length) { busy = false; return; }
      return fix.reduce(function (p, i) {
        return p.then(function () {
          return fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: i.key, quantity: limitFor(i) }) });
        });
      }, Promise.resolve()).then(function () { window.location.reload(); });
    }).catch(function () { busy = false; });
  }
  function start() {
    capInputs();
    guardCart();
    // Horizon has no public "cart changed" event — watch the theme's own cart requests instead
    if (window.fetch && !window.__pdFetchWrapped) {
      window.__pdFetchWrapped = true;
      var orig = window.fetch;
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var p = orig.apply(this, arguments);
        if (/\/cart\/(add|change|update)(\.js)?/.test(url)) p.then(function () { setTimeout(guardCart, 300); }).catch(function () {});
        return p;
      };
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
